export default __webpack_public_path__ + "static/media/csv-picto.da023277.svg";